import React from 'react'

const Install = () => {
    return (
        <div>
            <h3>Follow the link to install <span role="img" aria-label="finger-down">👇</span></h3>
            <a href="https://metamask.io/download.html">Meta Mask</a>
        </div>
    );
};

export default Install;